import { Component, Input, Output, EventEmitter, OnInit, Injector } from '@angular/core';
import { GameSettingsService } from '@app/main/content/game-settings/game-settings.service';
import { AdminApi } from '@lbsdk/*';
import { FuseSplashScreenService } from '@fuse/services/splash-screen.service';
import { HelperService } from '@app/main/core/services/helper.service';
import { MockResourcesService } from '../../services/mock-resources.service';

@Component({
  selector: 'app-game-assets-settings',
  templateUrl: './game-assets-settings.component.html',
  styleUrls: ['./game-assets-settings.component.scss']
})
export class GameAssetsSettingsComponent implements OnInit {
  @Input() data: any; // The game data object
  @Input() color1: string;
  @Input() color2: string;
  @Input() s3BucketUrl: string;
  @Input() menuArt: string;
  @Input() drawDate: any;

  @Output() color1Change = new EventEmitter<string>();
  @Output() color2Change = new EventEmitter<string>();
  @Output() dataChange = new EventEmitter<any>();
  
  public gameSettingsService: GameSettingsService;

  locationIcon: string;

  constructor(
    private injector: Injector,
    private adminApi: AdminApi,
    private fuseSplashScreenService: FuseSplashScreenService,
    private helperService: HelperService,
    public mockResourcesService: MockResourcesService
  ) {}

  async ngOnInit() {
    this.gameSettingsService = this.injector.get(GameSettingsService);

    // Initialize default values if missing
    if (!this.data) {
      this.data = {};
    }
    if (!this.data.header) this.data.header = { image: "", scale: 1 };
    if (!this.data.prizeBackground) this.data.prizeBackground = { image: "", scale: 1 };
    if (!this.data.buttonBackground) this.data.buttonBackground = { opacity: 0 };

    const locationIcon = await this.mockResourcesService.getLocationIcon();
    if (locationIcon) {
      this.locationIcon = this.s3BucketUrl + locationIcon.value;
    }
  }

  // Generic handler for image uploads
  onImageUpload(event: any, type: string) {
    let file: File;
    if (event instanceof File) {
        file = event;
    } else if (event && event.target && event.target.files && event.target.files.length) {
        file = event.target.files[0];
    } else {
        return;
    }
    
    this.uploadFile(file, type);
  }

  onImageEdited(result: any, type: string) {
      if (result && result.blob) {
          this.uploadFile(result.blob, type);
      }
  }

  private uploadFile(file: Blob | File, type: string) {
      this.fuseSplashScreenService.show();
      
      // Determine upload path - reusing inviteImageArtUploadPath as a default container
      // If specific containers exist for these, we should switch.
      const uploadPath = this.gameSettingsService.inviteImageArtUploadPath;

      // Compress if it's a File (not Blob from editor which is already processed or we might want to skip compression for edited)
      // For simplicity, we upload directly or compress if it's a large raw file. 
      // HelperService.compressImage expects a File.
      
      let uploadPromise;

      if (file instanceof File) {
           uploadPromise = this.helperService.compressImage(file).then(res => res.compressedBlob);
      } else {
          uploadPromise = Promise.resolve(file);
      }

      uploadPromise.then(blob => {
          return this.gameSettingsService.uploadImage(
            blob,
            uploadPath,
            this.adminApi.getCurrentToken().id
          ).toPromise();
      }).then((response: any) => {
          const result = response.result || response;
          const files = result.files || result; // Fallback if files is direct
          // Adjust based on observation that 'files' might be 'file' array directly or object with 'file' key
          const fileList = files["file"] || files;
          
          if (!fileList || !fileList[0]) {
             console.error("Unexpected upload response structure:", response);
             // The promise RESOLVED, so the .catch below never runs. Without this
             // the splash overlay stays up forever and the admin looks frozen.
             this.fuseSplashScreenService.hide();
             return;
          }

          const providerResponse = fileList[0]["providerResponse"] || fileList[0];
          const imageName = providerResponse.name;
          
          // Update data model
          if (this.data[type]) {
              this.data[type].image = imageName;
          } else {
              this.data[type] = { image: imageName, scale: 1 };
          }

          this.fuseSplashScreenService.hide();
          this.dataChange.emit(this.data);
      }).catch(error => {
          console.error("Upload failed", error);
          this.fuseSplashScreenService.hide();
      });
  }
}
